import type { Dict } from "./cs";

// English dictionary. Typed against `Dict`, so a missing or stray key fails the
// build (and test/i18n.test.ts re-checks parity).
export const en: Dict = {
  // Top bar
  "topbar.locating": "Locating…",
  "topbar.locate": "📍 Find me",
  "topbar.addCancel": "Cancel",
  "topbar.add": "+ Add toilet",

  // Filters
  "filters.wheelchair": "♿ Accessible",
  "filters.free": "🆓 Free",
  "filters.changingTable": "🍼 Changing table",
  "filters.count": "{n} toilets",
  "filters.countTruncated": "{n}+ toilets · zoom in",

  // Map
  "map.addHint": "Click the map where the toilet is.",

  // Toilet detail
  "detail.dialogLabel": "Toilet detail",
  "detail.close": "Close",
  "detail.defaultName": "Public toilet",
  "detail.paid": "💰 Paid",
  "detail.free": "🆓 Free",
  "detail.wheelchair": "♿ Accessible",
  "detail.changingTable": "🍼 Changing table",
  "detail.distance": "📏 {d} away",
  "detail.navigate": "🧭 Directions",
  "detail.shared": "✓ Copied",
  "detail.share": "🔗 Share",
  "detail.openPage": "📄 Toilet page",

  // Add toilet form
  "form.title": "New toilet",
  "form.name": "Name (optional)",
  "form.namePlaceholder": "e.g. toilet by the park",
  "form.wheelchair": "Wheelchair accessible",
  "form.fee": "Paid",
  "form.changingTable": "Changing table",
  "form.openingHours": "Opening hours",
  "form.openingHoursPlaceholder": "Mon–Fri 8–20",
  "form.note": "Note",
  "form.cancel": "Cancel",
  "form.saving": "Saving…",
  "form.save": "Save",
  "form.error": "Something went wrong.",
  "form.missingSiteKey":
    "Adding toilets is temporarily unavailable – the anti-spam configuration is missing.",

  // Sharing
  "share.copyPrompt": "Copy the link:",

  // Street-level preview
  "streetview.open": "🗺️ Open the area in Street View",
  "streetview.expand": "Show the interactive preview of the area",

  // Geolocation
  "geo.userPos": "Your location",
  "geo.unsupported": "Your browser does not support geolocation.",
  "geo.failed": "Could not determine your location: {error}",

  // Countries
  "country.label": "Country",
  "country.cz": "Czechia",
  "country.at": "Austria",
};
